import type { Account, AccountModule, UserSettings } from '@/api/auth';

/** Legacy `Constants.BetBuilder` limits. */
export const BET_BUILDER_MIN_SELECTIONS = 2;
export const BET_BUILDER_MAX_SELECTIONS = 10;

/** UsersAPI hard-caps Custom packages per ticket at 1. */
export const BET_BUILDER_MAX_CUSTOM_LEGS = 1;

function modulesList(
  account: Account | null | undefined,
  user: UserSettings | null | undefined,
): AccountModule[] {
  const enabled = account?.EnabledModules;
  if (Array.isArray(enabled) && enabled.length > 0) return enabled;
  const userModules = user?.Modules;
  if (Array.isArray(userModules) && userModules.length > 0) return userModules;
  const accountModules = account?.Modules;
  if (Array.isArray(accountModules) && accountModules.length > 0) return accountModules;
  return [];
}

/**
 * Legacy `IsBetBuilderEnabled` — module gate via account/user `betbuilder` module.
 */
export function isBetBuilderEnabled(
  account: Account | null | undefined,
  user?: UserSettings | null,
): boolean {
  return modulesList(account, user).some(
    (mod) => typeof mod?.Name === 'string' && mod.Name.toLowerCase() === 'betbuilder',
  );
}

/** Prematch-only offer: module on + event flag + not live. */
export function isBetBuilderAvailableForEvent(options: {
  account: Account | null | undefined;
  user?: UserSettings | null;
  betBuilderAvailable?: boolean | null;
  live?: boolean | null;
}): boolean {
  if (!isBetBuilderEnabled(options.account, options.user)) return false;
  if (options.live === true) return false;
  return options.betBuilderAvailable === true;
}
